import { motion } from 'motion/react'
import { cn } from '@/utils/styles/cn'

interface IPaginationDotsProps {
    className?: string
    pagesCount: number
    currentPage: number
    activeColorClassName?: string
    inactiveColorClassName?: string
    onPageChange?: (page: number) => void
}

export const PaginationDots = ({
    className,
    currentPage,
    pagesCount,
    activeColorClassName = 'bg-neotaste',
    inactiveColorClassName = 'bg-white',
    onPageChange,
}: IPaginationDotsProps) => {
    const isHidden = pagesCount <= 1

    return (
        <div className={cn('flex justify-center mt-2 gap-x-3', className, isHidden && 'hidden')}>
            {Array.from({ length: pagesCount }, (_, index) => {
                const isCurrentPage = currentPage === index + 1

                return (
                    <motion.div
                        initial={{ scale: isCurrentPage ? 1.5 : 1 }}
                        animate={{ scale: isCurrentPage ? 1.5 : 1 }}
                        key={index}
                        className={cn(
                            'min-w-2 min-h-2 rounded-full shadow-custom',
                            isCurrentPage ? activeColorClassName : inactiveColorClassName
                        )}
                        onClick={() => onPageChange?.(index + 1)}
                    />
                )
            })}
        </div>
    )
}
